import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Text, Button, Logo } from '@deseretbook/react-ui'

import './Login.css'

const LoginWrapper = ({ children }) => {
  const isRegistration = document.location.pathname.includes('register')
  return (
    <Box alignItems="center" justifyContent="center" className="login-page">
      <Box className="login-container">
        <Logo
          style={{ maxWidth: '70px', maxHeight: '70px', marginBottom: '1rem' }}
          name="bookshelfBooks"
          alt="Deseret Bookshelf Books"
        />
        <Logo
          style={{ maxWidth: '260px', minWidth: '260px', minHeight: '22px', marginBottom: '40px' }}
          name="bookshelfTitle"
          alt="Deseret Bookshelf Title"
          svgProps={{ width: '260', height: '22' }}
        />
        {children}
        <Button
          className="forgot-password"
          onClick={() =>
            window.open(`${process.env.REACT_APP_DESERET_BOOK_BASE_URL}/password/recover`)
          }
        >
          Forgot Password?
        </Button>
        <Box className="register-link">
          <Text>{isRegistration ? 'Already' : "Don't"} have an account?</Text>
          {isRegistration ? <Link to="/login">Sign in</Link> : <Link to="/register">Sign up</Link>}
        </Box>
      </Box>
    </Box>
  )
}

export default LoginWrapper
